import HttpService from "@core/services/http/http.service";
import { Signal } from "@core/services/http/http.type";
import {
  AuthorRevenue,
  BookInteraction,
  BookPurchase,
  BookRevenue,
  GeneralInformation,
  PaymentInformation,
  RequestParamsDashboard,
  ResponseVoucherActiveInteraction,
  ResponseVoucherActiveUses,
  VoucherActiveInteraction,
  VoucherActiveUses,
} from "@app/types/dashboard.type";
import { GetDetailResponse } from "@app/types";

class _DashboardService {
  public getVoucherActiveInteraction(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<
      ResponseVoucherActiveInteraction<VoucherActiveInteraction>
    >("/admin/api/v2/dashboard/voucher-active-interaction", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public getVoucherActiveUses(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<ResponseVoucherActiveUses<VoucherActiveUses>>(
      "/admin/api/v2/dashboard/voucher-active-uses",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getGeneralInformation(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<GeneralInformation>>(
      "/admin/api/v2/dashboard/general-information",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getPaymentInformation(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<PaymentInformation>>(
      "/admin/api/v2/dashboard/payment-information",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookRevenue(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookRevenue>>(
      "/admin/api/v3/dashboard/book-revenue",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookRevenueRetail(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookRevenue>>(
      "/admin/api/v3/dashboard/admin-revenue-retail",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookRevenueVip(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookRevenue>>(
      "/admin/api/v3/dashboard/book-revenue-vip",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getAuthorRevenue(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<AuthorRevenue>>(
      "/admin/api/v3/dashboard/author-revenue",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookPurchase(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookPurchase>>(
      "/admin/api/v2/dashboard/book-purchase",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookInteractions(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookInteraction>>(
      "/admin/api/v2/dashboard/book-interactions",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }
}

const DashboardService = new _DashboardService();

export default DashboardService;
